import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function createRangeClass(payload) {
	let createdRangeClass = null;
	const { sectionID, rangeClassLabel, active } = payload;

	try{
		const content = {
			method: API_POST_METHOD,
			url: `settings/examresultrangeclass`,
			data:{
				p_section_id: sectionID,
				p_range_class_label: rangeClassLabel,
				p_active: active
			} 
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		createdRangeClass = data.RECORDS;
	}
	catch(e) {
		showMessage(e);
	}

	return createdRangeClass;
}

export async function updateRangeClass(payload) {
	let updatedRangeClass = null;
	const { sectionID, rangeClassID , rangeClassLabel, active } = payload;

	try{
		const content = {
			method: API_PUT_METHOD,
			url: `settings/examresultrangeclass`,
			data:{
				p_section_id: sectionID,
				p_range_class_id: rangeClassID,
				p_range_class_label: rangeClassLabel,
				p_active: active
			} 
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		updatedRangeClass = data.RECORDS;
	}
	catch(e) {
		showMessage(e);
	}

	return updatedRangeClass;
}

export async function getAllRangeClass(payload) {
	let rangeClass = [];

	try{
		const content = {
			method: API_GET_METHOD,
			url: `settings/examresultrangeclass`,
			data: payload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		rangeClass = data.RECORDS;
	}
	catch(e) {
		showMessage(e);
	}

	return rangeClass;
}

export async function applySorting(dataPayload) {
	let result = null;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/examresultrangeclasssorting',
			data: {
				p_range_class_sorting_array: JSON.stringify(dataPayload),
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200) {
			result = data;
		}
	} catch (e) {
		showMessage(e);
	}

	return result;
}
